import { render, staticRenderFns } from "./App.vue?vue&type=template&id=5533594a&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "./App.vue?vue&type=style&index=0&id=5533594a&prod&lang=css&"
import style1 from "./utils/content-scripts/content-script.scss?vue&type=style&index=1&prod&lang=scss&"
import style2 from "./App.vue?vue&type=style&index=2&id=5533594a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports